import classNames from "classnames";
import React from "react";
import { useForm } from "react-hook-form";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";
import { useUpsellWidgetContainer } from '../../hooks/useUpsellWidgetContainerContext';
import { useUpsellWidgetModel } from '../../hooks/useUpsellWidgetModelContext';
import { EmailInput, PasswordInput, RememberMeCheckbox } from "./FormControls";

export const Step8ExistingUserLogin = () => {
  const model = useUpsellWidgetModel();
  const { boldClass, goToStep } = useUpsellWidgetContainer();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch
  } = useForm();
  const onSubmit = (data) => {
    onCaptchaSubmit(data);
  };

  const onCaptchaSubmit = (data) => {
    //onCaptchaSubmit(data);
  };

  return (
    <div className="step3">
      <div className="row mb-3">
        <div className="col-6 pr-0">
          <a href="#" className={classNames(
            "full-width d-block py-2 border-bottom-4-gray-21-with-hover font-19",
            model.isCompPage ? "text-white" : "text-color-gray-16 hover-color-brand-green",
            boldClass
          )} onClick={(e) => {
            e.preventDefault();
            goToStep(UpsellPanelSteps.Step1SignUp);
          }}
          >
            Sign up
          </a>
        </div>
        <div className="col-6 pl-0">
          <div className={classNames(
            "full-width d-block py-2 border-bottom-4-deep-blue-2 font-19",
            model.isCompPage ? "text-white border-bottom-4-brand-green" : "text-color-deep-blue-2",
            boldClass
          )}
            onClick={() => goToStep(UpsellPanelSteps.Step3Login)}
          >
            Log in
          </div>
        </div>
      </div>
      <form className="join-form-inline form-is-custom form-disable-pristine-error" onSubmit={handleSubmit(onSubmit)} noValidate >
        <div className="row">
          <div className="col-md-12">
            <EmailInput register={register} errors={errors} />
          </div>
          <div className="col-md-12">
            <PasswordInput register={register} errors={errors} placeholderText="Enter Password" />
          </div>
          <div className="col-md-12 text-left">
            <RememberMeCheckbox register={register} />
          </div>
          <div className="col-md-12 col-12">
            {/* Placeholder for reCAPTCHA */}
            <div id="reCaptcha"></div>
            <button className={`btn btn-primary btn-fw btn-brand-style-with-pad-sm font-19-no-line-height ${boldClass}`} type="submit" >
              Login
            </button>
          </div>
          <div className="col-md-12 col-12">
            <p className="forgot-pwd">
              Forgotten password?{" "}
              <a href="#" className="link-primary" onClick={(e) => {
                e.preventDefault();
                goToStep(UpsellPanelSteps.Step16ForgotPassword);
              }}
              >
                Click here
              </a>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
};
